module.exports = __webpack_public_path__ + "src/img/close.8b9d0cc6.svg";